import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-cell',
  template: '@if (status?.length) {<span [ngClass]="statusClasses"> {{ status }}</span>}',
  styleUrls: ['./status-cell-renderer.component.scss'],
  standalone: false,
})
export class StatusCellComponent {
  @Input() status?: string;

  get statusClasses(): string {
    switch (this.status?.toLowerCase()) {
      case 'calculating':
        return 'text-warning text-sm';

      case 'disposed':
        return 'badge rounded-pill bg-warning text-white';

      case 'pooled':
        return 'badge rounded-pill bg-primary text-white';

      case 'in use':
        return 'badge rounded-pill bg-success text-white';

      case 'purchased':
        return 'badge rounded-pill bg-info text-white';

      case 'errored':
        return 'badge rounded-pill bg-danger text-white';

      default:
        return 'badge rounded-pill bg-light text-dark';
    }
  }
}
